import { call, put, takeLatest } from 'redux-saga/effects';
import {
  staffAddFailure,
  staffAddSuccess,
  staffDeleteFailure,
  staffDeleteSuccess,
  staffFetchAllFailure,
  staffFetchAllSuccess,
  staffUpdateFailure,
  staffUpdateSuccess,
  staffViewAllFailure,
  staffViewAllSuccess,
  StaffViewFailure,
  StaffViewSuccess,
} from './StaffAction';
import {
  staffAddEffect,
  staffDeleteEffect,
  staffFetchAllEffect,
  staffUpdateEffect,
  staffViewAllEffect,
  staffViewEffect,
} from './StaffEffect';
import {
  STAFF_ADD_REQUEST,
  STAFF_DELETE_REQUEST,
  STAFF_FETCH_ALL_REQUEST,
  STAFF_UPDATE_REQUEST,
  STAFF_VIEW_ALL_REQUEST,
  STAFF_VIEW_REQUEST,
} from './StaffType';
function* StaffViewSaga({ payload }) {
  try {
    let { data } = yield call(staffViewEffect, payload);

    yield put(StaffViewSuccess(data.data));
  } catch (err) {
    yield put(
      StaffViewFailure({
        error: true,
      })
    );
  }
}
function* staffAddSaga({ payload }) {
  try {
    let response = yield call(staffAddEffect, payload);
    console.log('Addsage', response);
    yield put(staffAddSuccess(response));
  } catch (err) {
    console.log('sage', err);
    yield put(staffAddFailure(err.errorFields));
  }
}
function* staffUpdateSaga({ payload }) {
  try {
    let response = yield call(staffUpdateEffect, payload);

    yield put(staffUpdateSuccess(response));
  } catch (err) {
    console.log('sagastaf', err);
    yield put(staffUpdateFailure(err.message));
  }
}

function* staffViewAllSaga({ payload }) {
  try {
    const response = yield call(staffViewAllEffect, payload);

    yield put(staffViewAllSuccess(response));
  } catch (error) {
    yield put(staffViewAllFailure(error || 'Failed to fetch staff'));
  }
}
function* staffFetchAllSaga() {
  try {
    console.log('staff sagaa');
    const response = yield call(staffFetchAllEffect);

    yield put(staffFetchAllSuccess(response));
  } catch (error) {
    yield put(staffFetchAllFailure(error || 'Failed to fetch staff'));
  }
}

function* staffDeleteSaga({ payload }) {
  try {
    const response = yield call(staffDeleteEffect, payload);
    console.log('staffdata', response);
    yield put(staffDeleteSuccess(response));
  } catch (error) {
    yield put(staffDeleteFailure(error));
  }
}

export default function* staffSaga() {
  yield takeLatest(STAFF_VIEW_REQUEST, StaffViewSaga);
  yield takeLatest(STAFF_ADD_REQUEST, staffAddSaga);
  yield takeLatest(STAFF_UPDATE_REQUEST, staffUpdateSaga);
  yield takeLatest(STAFF_VIEW_ALL_REQUEST, staffViewAllSaga);
  yield takeLatest(STAFF_DELETE_REQUEST, staffDeleteSaga);
  yield takeLatest(STAFF_FETCH_ALL_REQUEST, staffFetchAllSaga);
}
